/**
 * /tenants/$slug/authentication/authenticators/new — create page.
 */

import { createFileRoute } from "@tanstack/react-router";
import { AddAllowlistEntryPage } from "@/features/authenticator-allowlist/pages/add-allowlist-entry-page";

export const Route = createFileRoute(
  "/_authed/tenants/$slug/authentication/authenticators/new",
)({
  component: AddAllowlistEntryPage,
});
